// Client-side usage beacons: report billable Google Maps events to the backend so
// they show up in the owner cost dashboard. Batched (module-level queue, flushed on
// a timer + when the tab is hidden/unloaded) so we never add a request per keystroke.
// Best-effort — failures are swallowed.
import { apiUrl } from './api';

let queue = [];
let timer = null;

function flush() {
  if (!queue.length) return;
  const body = JSON.stringify({ events: queue });
  queue = [];
  const url = apiUrl('/api/usage/beacon');
  try {
    if (navigator.sendBeacon) {
      // Same-origin in prod (nginx) → session cookie rides along → correct attribution.
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(url, {
        method: 'POST', credentials: 'include', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body,
      }).catch(() => {});
    }
  } catch (_e) { /* best-effort */ }
}

// Report one billable event (service/api must be on the backend beacon allowlist).
export function reportUsage(service, api, units = 1) {
  queue.push({ service, api, units });
  if (queue.length >= 40) { flush(); return; }
  if (!timer) {
    timer = setTimeout(() => { timer = null; flush(); }, 10000);
  }
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);
}
